import { render, staticRenderFns } from "./TableFactors.vue?vue&type=template&id=d316edd8&scoped=true"
import script from "./TableFactors.js?vue&type=script&lang=js&external"
export * from "./TableFactors.js?vue&type=script&lang=js&external"
import style0 from "./TableFactors.vue?vue&type=style&index=0&id=d316edd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d316edd8",
  null
  
)

export default component.exports